import { Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { Channel } from "app/js/src/domain/channel";
import { ChannelRepository } from "app/js/src/domain/channel-repository";
import { CsvExportService } from "app/js/src/services/csv-export.service";
import { ReportsService } from "app/js/src/services/reports.service";
import { SessionStorageService } from "app/js/src/services/session-storage.service";
import { CalendarDatepickerComponent } from "../../calendar/calendar-datepicker.component";
import moment from "moment";
import { ColDef, GridApi, GridOptions } from "ag-grid-community";
import { UserService } from "app/js/src/domain/user-service";
const LAST_SELECTED_CHANNELS_KEY =
  "reports::scheduler_alerts::last_selected_channels";
const LAST_SELECTED_ISSUE_TYPE =
  "reports::scheduler_alerts::last_selected_issue_type";
@Component({
  selector: "evrideo-scheduler-alerts-report",
  templateUrl: "./scheduler-alerts-report.component.html",
  styleUrls: ["./scheduler-alerts-report.component.scss"],
})
export class SchedulerAlertsReportComponent implements OnInit, OnDestroy {
  constructor(
    private reportsService: ReportsService,
    private channelRepository: ChannelRepository,
    private sessionStore: SessionStorageService,
    private csvExportService: CsvExportService,
    private userService: UserService,
  ) {}
  @ViewChild(CalendarDatepickerComponent)
  datePicker: CalendarDatepickerComponent;
  channelTimezones: { [key: number]: string } = {};
  activeChannelsList = [];
  issueTypesList = [
    { item_id: 0, item_text: "Gaps Issues" },
    { item_id: 1, item_text: "Missing Audio" },
    { item_id: 2, item_text: "Missing Subtitles" },
    { item_id: 3, item_text: "Empty Contracts" },
    { item_id: 4, item_text: "Upload Playlist" },
  ];
  selectedIssueTypes = [];
  selectedChannelsList = [];

  dateTo: moment.Moment;
  autoRefresh: boolean;
  autoRefreshInterval: any;
  isLoading = false;

  data: any;
  sortInfo = {
    column: 1,
    ascending: false,
  };

  lastResult: any[];

  gridApi: GridApi;
  gridColumnApi: any;
  gridOptions: GridOptions;
  columnDefs: ColDef[] = [
    {
      headerName: "Channel Name",
      field: "ChannelName",
    },
    {
      headerName: "Issue Type",
      field: "IssueType",
    },
    {
      headerName: "Issue Text",
      field: "IssueText",
      sortable: false,
      cellRenderer: this.formatIssueText.bind(this),
      wrapText: true,
      autoHeight: true,
    },
    {
      headerName: "Relevant Date UTC",
      field: "RelevantDateTimeUtc",
      cellRenderer: this.formatDateTimeUTC.bind(this),
    },
    {
      headerName: "Relevant Date Channel TZ",
      field: "RelevantDateInChannelTZ",
      cellRenderer: this.formatDateTimeTZ.bind(this),
    },
    {
      headerName: "Relevant ID",
      field: "RelevantId",
    },
  ];
  public pageSize = 20;
  overlayLoadingTemplate = ` <img src="./assets/loader3.svg" style="position:absolute;top:50%;left:50%;" alt="loading..." />`;
  overlayNoRowsTemplate =
    '<span style="padding: 10px; border: 2px solid #666; background: #55AA77;">No schedule alerts found!</span>';

  ngOnInit() {
    this.fillDropdowns();
    this.dateTo = moment().add(1, "days");
    this.gridOptions = <GridOptions>{
      columnDefs: this.columnDefs,
      context: { componentParent: this },
      defaultColDef: {
        resizable: false,
        lockPosition: true,
        sortable: true,
        flex: 1,
        cellStyle: { "line-height": "44px" },
      } as ColDef,
      rowHeight: 44,
      animateRows: true,
      paginationAutoPageSize: false,
      paginationPageSize: this.pageSize,
      pagination: true,
      enableCellTextSelection: true,
      getRowHeight: (e) => {
        let height = 44;
        return height;
      },
    };
  }

  // onChartReady() {
  //   if (this.onChartReadyCalled) {
  //     return;
  //   }
  //   google.visualization.events.addListener(this.chart.wrapper.getChart(), "sort", (sortInfo) => {
  //     this.sortInfo = sortInfo;
  //   });
  //   if (this.selectedIssueTypes.length > 0) {
  //     this.getSchedulerAlerts();
  //   }
  //   this.onChartReadyCalled = true;
  // }

  showDatepicker(): void {
    this.datePicker.show();
  }

  hideDatepicker() {
    this.datePicker.hide();
  }

  onClickedOutside() {
    this.datePicker.hide();
  }

  onDatepickerApply(newDate) {
    this.hideDatepicker();
    this.dateTo = newDate;
  }

  private async fillDropdowns(): Promise<void> {
    try {
      const tenantChannels = await this.channelRepository.getTenantChannels();
      const active_channels = tenantChannels.filter(
        (c) => !c.isBlock && c.isActive,
      );
      this.activeChannelsList = active_channels.map((x: Channel) => {
        return { item_id: x.id, item_text: x.name };
      });
      active_channels.forEach((channel) => {
        this.channelTimezones[channel.id] =
          this.userService.getTimezoneValueById(channel.timezoneId);
      });

      const lastSelectedChannels = this.sessionStore.getItemAsJsonObject(
        LAST_SELECTED_CHANNELS_KEY,
      );

      const activeChannlesIds = this.activeChannelsList.map((c) => c.item_id);
      if (lastSelectedChannels) {
        //merge channels
        this.selectedChannelsList = lastSelectedChannels.filter((i) =>
          activeChannlesIds.includes(i),
        );
      } else {
        //select all channels by default
        this.selectedChannelsList = activeChannlesIds || [];
      }
      this.selectedIssueTypes =
        this.sessionStore.getItemAsJsonObject(LAST_SELECTED_ISSUE_TYPE) ||
        this.issueTypesList.map((x) => x.item_id);
    } catch (err) {
      console.error("fillDropdowns-> Error ", err);
    }
  }

  updateSelectedChannels(event) {
    console.log(event);
    this.selectedChannelsList = event;
    this.saveFiltersState();
  }
  updateSelectedIssueTypes(event) {
    console.log(event);
    this.selectedIssueTypes = event;
    this.saveFiltersState();
  }
  saveFiltersState() {
    this.sessionStore.setItem(
      LAST_SELECTED_ISSUE_TYPE,
      this.selectedIssueTypes,
    );
    this.sessionStore.setItem(
      LAST_SELECTED_CHANNELS_KEY,
      this.selectedChannelsList,
    );
  }

  ngOnDestroy(): void {
    if (this.autoRefreshInterval) {
      clearInterval(this.autoRefreshInterval);
    }
  }

  async getSchedulerAlerts() {
    //console.log('getSchedulerAlerts-> ',this.dateFrom.getTi,this.dateTo)
    this.isLoading = true;
    try {
      const res = await this.reportsService.getSchedulerAlerts(
        this.selectedIssueTypes,
        this.selectedChannelsList,
        moment().unix(),
        this.dateTo.unix(),
      );
      if (res) {
        this.lastResult = res;
        this.gridApi.setGridOption("rowData", res);
      }
    } finally {
      this.isLoading = false;
    }
  }
  formatIssueText(param: any) {
    if (!param.value) {
      return "";
    }
    return `<div>${param.value}</div>`;
  }
  formatDateTimeUTC(param: any) {
    if (!param.value) {
      return "";
    }
    return moment(param.value).utc(true).format("Y/MM/DD HH:mm Z");
  }
  formatDateTimeTZ(param: any) {
    if (!param.value) {
      return "";
    }
    var time = moment(param.value);
    if (param.data) {
      time = time.tz(this.channelTimezones[param.data.ChannelId], true);
    }

    return time.format("Y/MM/DD HH:mm Z");
  }
  saveAsCSV() {
    const formattedResult =
      this.lastResult &&
      this.lastResult.map((row) => {
        return {
          TenantName: row.TenantName,
          "Channel Name": row.ChannelName,
          "Issue Type": row.IssueType,
          "Issue Text": row.IssueText,
          "Relevant Date Time UTC": row.RelevantDateTimeUtc,
          "Relevant Date In Channel TZ": row.RelevantDateInChannelTZ,
          "Relavant Id": row.RelevantId,
        };
      });
    this.csvExportService.exportToCsv(
      `${this.lastResult[0].TenantName}-SchedulerAlerts-${moment().unix()}.csv`,
      formattedResult,
    );
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.sizeColumnsToFit();
    if (this.selectedIssueTypes.length > 0) {
      this.getSchedulerAlerts();
    }
    //this.scheduledHistoricalJobCacheUpdated =      this.recordingService.getRecordingHistoricalJobCacheUpdateObserver().subscribe(this.updateJobsInGrid.bind(this));
  }
  get pageCount() {
    let firstRow = 0;
    let lastRow = this.pageSize;
    let finalRow: string | number = "more";
    if (this.gridApi) {
      const pageSize = this.gridApi.paginationGetPageSize();
      const currentPage = this.gridApi.paginationGetCurrentPage();
      firstRow = currentPage * pageSize;
      lastRow = firstRow + pageSize;
      const vc = this.gridApi.getDisplayedRowCount();
      if (vc) {
        finalRow = vc;
      }
      if (currentPage + 1 == this.gridApi.paginationGetTotalPages()) {
        lastRow = vc;
      }
    }
    return `${firstRow + 1}-${parseInt(lastRow.toString(), 10)} of ${finalRow}`;
  }
  get pagesView() {
    let thisPage = 0;
    let lastPage: string | number = "more";
    if (this.gridApi) {
      thisPage = this.gridApi.paginationGetCurrentPage();
      lastPage = this.gridApi.paginationGetTotalPages();
    }
    return `Page ${thisPage + 1} of ${lastPage}`;
  }
  setPageSize(pageSize: number) {
    this.pageSize = pageSize;
    if (this.gridApi) {
      this.gridApi.setGridOption("paginationPageSize", this.pageSize);
      this.gridApi.setGridOption("cacheBlockSize", this.pageSize);
      this.gridApi.expireValueCache();
      this.getSchedulerAlerts();
    }
  }
  goToPage(pos) {
    if (this.gridApi) {
      switch (pos) {
        case "first":
          this.gridApi.paginationGoToFirstPage();
          break;
        case "previous":
          this.gridApi.paginationGoToPreviousPage();
          break;
        case "next":
          this.gridApi.paginationGoToNextPage();
          break;
        case "last":
          this.gridApi.paginationGoToLastPage();
          break;
        default:
          break;
      }
    }
  }
}
